// eslint-disable-next-line import/no-restricted-paths
import isEqual from "lodash.isequal";
import { useCallback, useMemo } from "react";

import type { S3Object } from "@/lib/gql/__generated__/graphql";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import { useMarketingCampaignFormModelContext } from "../../../../context";

import type { MarketingCampaignFormModel } from "../../../../../../model/type";

export const useCampaignKeyVisual = () => {
	const { viewModel, onSetViewModel } = useMarketingCampaignFormModelContext();
	const { mainKeyVisual } = viewModel;

	const isEditedMainKV = !isEqual(mainKeyVisual, DUMMY_IMAGE.s3Object);

	const hasErrorMainKV =
		Boolean(mainKeyVisual.bucket.error) ||
		Boolean(mainKeyVisual.key.error) ||
		Boolean(mainKeyVisual?.mimeType?.error) ||
		Boolean(mainKeyVisual?.fileName?.error) ||
		Boolean(mainKeyVisual?.region.error) ||
		false;
	const errorMessageMainKV =
		mainKeyVisual.bucket.error ||
		mainKeyVisual.key.error ||
		mainKeyVisual.mimeType?.error ||
		mainKeyVisual.fileName?.error ||
		mainKeyVisual.region.error;

	const onSetMainKeyVisual = useCallback(
		(value: S3Object | null) => {
			const s3Object = value;

			const newMainKeyVisual = {
				key: {
					isEdited: true,
					value: s3Object?.key ?? "",
				},
				bucket: {
					isEdited: true,
					value: s3Object?.bucket ?? "",
				},
				mimeType: {
					isEdited: true,
					value: s3Object?.mimeType ?? "",
				},
				fileName: {
					isEdited: true,
					value: s3Object?.fileName ?? "",
				},
				region: {
					isEdited: true,
					value: s3Object?.region ?? "",
				},
			} satisfies MarketingCampaignFormModel["ViewModel"]["mainKeyVisual"];

			onSetViewModel([
				{
					key: "mainKeyVisual",
					value: newMainKeyVisual,
				},
			]);
		},
		[onSetViewModel],
	);

	const rawMainKeyVisual: S3Object = useMemo(() => {
		return {
			bucket: mainKeyVisual.bucket.value,
			key: mainKeyVisual.key.value,
			region: mainKeyVisual.region.value,
			mimeType: mainKeyVisual.mimeType?.value,
			fileName: mainKeyVisual.fileName?.value,
		} satisfies S3Object;
	}, [mainKeyVisual]);

	return {
		mainKeyVisual,
		rawMainKeyVisual,
		isEditedMainKV,
		hasErrorMainKV,
		errorMessageMainKV,
		onSetMainKeyVisual,
	};
};
